export default __webpack_public_path__ + "static/media/instagram.cc823554.svg";